import $ from 'jquery';
import map from 'vendor/google-maps-api';
import actions from 'framework/actions';

const searchActionSelector = '.js-omnibox-action';
const searchInputSelector = '.js-omnibox-input';
const errorLabelSelector = '.js-omnibox-error-label';
const isInvalidClass = 'is-invalid';

function initAutoComplete() {
	this.autoComplete = new google.maps.places.Autocomplete(
		this.$searchInput[0],
		{types: ['geocode']}
	);

	this.autoComplete.addListener('place_changed', this.placeChanged.bind(this));
}

export default class Omnibox {
	constructor(parentElement) {
		let options = {
			searchActionSelector: searchActionSelector,
			searchInputSelector: searchInputSelector,
			errorLabelSelector: errorLabelSelector,
			onSearch: null,
			searchOptions: {},
			type: 'omnibox'
		};

		this.parent = parentElement;
		this.options = options;
		this.apiInitialized = false;
	}

	initialize(opts) {
		var $parent = $(this.parent);

		Object.assign(this.options, opts || {});
		this.$searchAction = $parent.find(this.options.searchActionSelector);
		this.$searchInput = $parent.find(this.options.searchInputSelector);
		this.$errorLabel = $parent.find(this.options.errorLabelSelector);

		if(this.options.onSearch != null) {
			this.$searchAction.on('click', this.handleSearchClick.bind(this));
		}

		this.$searchInput.val(this.options.initialVal || '');

		function onFocus() {
			this.initializeApi();
			this.$searchInput.off('focus', onFocus.bind(this));
		}

		this.$searchInput.on('focus', onFocus.bind(this));
	}

	initializeApi() {
		return new Promise((resolve) => {
			if(this.apiInitialized) {
				resolve();
			} else{
				this.apiInitialized = true;
				map.initialize().then(() => {
					initAutoComplete.bind(this)();
				});
			}
		});

	}

	placeChanged() {
		var place = this.autoComplete.getPlace(),
			textQuery = place.formatted_address || place.name,
			query = textQuery,
			geo = place.geometry,
			isStateSearch = false;

		if(place && place.address_components && place.address_components.length) {
			isStateSearch = place.address_components.length <= 2 ? true : false;
		}

		if(geo) {
			query = {
				latitude: geo.location.lat(),
				longitude: geo.location.lng(),
				bounds: {
					sw: geo.viewport.getSouthWest(),
					ne: geo.viewport.getNorthEast()
				},
				stateSearch: isStateSearch
			};
		}

		this.query = query;
		this.queryText = textQuery;

		this.executeSearch();
	}

	handleSearchClick(evt) {
		if(evt && evt.preventDefault && typeof evt.preventDefault === 'function') {
			evt.preventDefault();
		}

		this.query = this.$searchInput.val();
		this.queryText = this.query;

		this.executeSearch();
	}

	executeSearch(evt) {
		if(evt && evt.preventDefault && typeof evt.preventDefault === 'function') {
			evt.preventDefault();
		}

		if(this.query && typeof this.options.onSearch === 'function') {
			this.options.onSearch({query: this.query, text: this.queryText, options: this.options.searchOptions});
			if (typeof this.options.onLoad === 'function') {
				this.options.onLoad();
			}
			actions.searchForNearestClub(this.query, this.options.queryLimit, this.options.distance,
				this.options.type, this.options.isLocator);
		}
	}

	setSearchInvalid() {
		this.$searchInput.addClass(isInvalidClass);
		this.$errorLabel.removeClass('hide');
	}

	setSearchValid() {
		this.$searchInput.removeClass(isInvalidClass);
		this.$errorLabel.addClass('hide');
	}
}
